const initialTenantState = {
 activeTenant: {}
};

export const tenantReducer = (state = initialTenantState, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_TENANT':
      return {
        ...state,
        activeTenant: action.payload
      };
    default:
      return state;
  }
};
